import { render } from "./DisplayAnnotationsFilterV2.vue?vue&type=template&id=42f301fc&scoped=true"
import script from "./DisplayAnnotationsFilterV2.vue?vue&type=script&lang=js"
export * from "./DisplayAnnotationsFilterV2.vue?vue&type=script&lang=js"

import "./DisplayAnnotationsFilterV2.vue?vue&type=style&index=0&id=42f301fc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f301fc"]])

export default __exports__